import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { transformCMSRichText } from '../../../utils/transformContent';
import { RenewalDataPropType } from '../../../propTypes/renewalData';
import { RENEWAL_HUB_CONTENT_PLACEHOLDER_KEY_MAP } from '../../../constants/cmsCodeName';
import './renewalAdjustPopup.scss';

export const RenewalAdjustPopup = ({ isOpen, onClose, title, body, renewalSummaryData }) => (
  <Modal
    size="small"
    open={isOpen}
    onClose={onClose}
    customCssClass="renewalAdjustPopup"
    isContentScrollable
    header={<h2 className="modal-title">{title}</h2>}
  >
    <div className="renewalAdjustPopup-content">
      {transformCMSRichText(body || '', '', renewalSummaryData, RENEWAL_HUB_CONTENT_PLACEHOLDER_KEY_MAP)}
    </div>
  </Modal>
);

RenewalAdjustPopup.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.string,
  renewalSummaryData: RenewalDataPropType
};
